import type { CSSProperties } from "react";

export type TooltipSide = "top" | "right";

/** Point the tooltip hangs from, in viewport coordinates. */
export interface TooltipPosition {
  x: number;
  y: number;
  /** Shown under the anchor because there was no room above it. */
  below?: boolean;
}

interface AnchorBox {
  top: number;
  bottom: number;
  left: number;
  right: number;
  width: number;
  height: number;
}

/** Space between the anchor and a tooltip on its right. */
export const SIDE_GAP = 10;
/** Space between the anchor and a tooltip above or below it. */
export const VERTICAL_GAP = 8;
/** Below this distance from the top of the viewport the tooltip flips under the anchor (e.g. header controls). */
export const MIN_ROOM_ABOVE = 40;

export function tooltipPosition(anchor: AnchorBox, side: TooltipSide): TooltipPosition {
  if (side === "right") return { x: anchor.right + SIDE_GAP, y: anchor.top + anchor.height / 2 };
  const centerX = anchor.left + anchor.width / 2;
  if (anchor.top < MIN_ROOM_ABOVE) return { x: centerX, y: anchor.bottom + VERTICAL_GAP, below: true };
  return { x: centerX, y: anchor.top - VERTICAL_GAP };
}

/** Inline style that hangs the tooltip from its position point. */
export function tooltipStyle(position: TooltipPosition, side: TooltipSide): CSSProperties {
  const anchorPoint = { left: position.x, top: position.y };
  if (side === "right") return { ...anchorPoint, transform: "translateY(-50%)" };
  return { ...anchorPoint, transform: position.below ? "translateX(-50%)" : "translate(-50%, -100%)" };
}
